import React, { useEffect, useState } from "react";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import { useGlobalContext } from "../context/context";
import { getWalletInvestmentPortfolio } from "../utils/investmentApi";

const walletAmountFormat = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const WalletHeader = () => {
  const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));
  const [walletPortfolio, setWalletPortfolio] = useState(null);
  const [walletLoading, setWalletLoading] = useState(true);
  const [walletError, setWalletError] = useState("");
  const [walletRetry, setWalletRetry] = useState(0);
  const {
    baseUrl,
    getAllDeposits,
    getAllWithdrawals,
    getUser,
  } = useGlobalContext();

  useEffect(() => {
    getAllDeposits(accessToken);
    getAllWithdrawals(accessToken);
    getUser(accessToken);
  }, []);

  useEffect(() => {
    let active = true;
    let requestCount = 0;

    const loadWalletBalance = async () => {
      const requestId = ++requestCount;
      setWalletLoading(true);
      setWalletError("");
      try {
        const response = await getWalletInvestmentPortfolio(baseUrl);
        const portfolio = response && response.portfolio;
        const balance = Number(portfolio && (portfolio.availableBalance ?? portfolio.cash));
        if (!Number.isFinite(balance)) {
          throw new Error("The investment service returned an invalid wallet balance.");
        }
        if (active && requestId === requestCount) {
          setWalletPortfolio({
            availableBalance: balance,
            currencySymbol: String(portfolio.currencySymbol || "").trim(),
            currencyCode: String(portfolio.currencyCode || "").trim(),
          });
        }
      } catch (error) {
        if (active && requestId === requestCount) {
          setWalletError(error.message || "Your wallet balance could not be loaded.");
        }
      } finally {
        if (active && requestId === requestCount) setWalletLoading(false);
      }
    };

    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") loadWalletBalance();
    };

    loadWalletBalance();
    window.addEventListener("focus", refreshWhenVisible);
    document.addEventListener("visibilitychange", refreshWhenVisible);
    return () => {
      active = false;
      window.removeEventListener("focus", refreshWhenVisible);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
    };
  }, [baseUrl, walletRetry]);

  const formattedBalance = walletPortfolio
    ? (walletPortfolio.currencySymbol || (walletPortfolio.currencyCode ? walletPortfolio.currencyCode + " " : "")) +
      walletAmountFormat.format(walletPortfolio.availableBalance)
    : "";

  return (
    <div className="account_total_item_one">
      <div>
        <div className="total_balance_sect">
          {walletLoading ? (
            <Skeleton width={160} height={15} />
          ) : (
            <h3 className="dashboard_h3">Your total balance</h3>
          )}
          {walletLoading ? (
            <Skeleton width={25} height={15} />
          ) : (
            <AiOutlineEyeInvisible color="#10215c" size={20} />
          )}
        </div>
        <h1>
          {walletLoading ? (
            <Skeleton width={300} height={50} />
          ) : walletError ? (
            <span role="alert" style={{ display: "inline-block", fontSize: "16px", lineHeight: 1.4 }}>
              {walletError}{" "}
              <button type="button" onClick={() => setWalletRetry((count) => count + 1)}>
                Retry
              </button>
            </span>
          ) : (
            formattedBalance
          )}
        </h1>
      </div>
    </div>
  );
};
export default WalletHeader;
